import { connect } from 'react-redux';
import { AboutComponent } from './about.component';

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({}); 

export const AboutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AboutComponent);